<pathPantalla></pathPantalla>

<div>
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <div>
                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [showColumnHeaders]="true"
                        (onExporting)="onExporting($event)"
                        >


                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column dataField="nomina" caption="Nº nómina"> </dxi-column>
                        <dxi-column dataField="nombre" caption="Nombre"> </dxi-column>
                        <dxi-column dataField="apellidopaterno" caption="Ap. paterno"> </dxi-column>
                        <dxi-column dataField="apellidomaterno" caption="Ap. materno"> </dxi-column>
                        <dxi-column dataField="fechanacimiento" caption="Fecha nacimiento" dataType="date" format="dd/MM/yyyy"> </dxi-column>
                        <dxi-column  dataField="rfc" caption="RFC"> </dxi-column>
                        <dxi-column dataField="curp" caption="CURP"> </dxi-column>
                        <dxi-column dataField="telefonocelular" caption="Tel. celular"> </dxi-column>
                        <dxi-column dataField="emailinstitucional" caption="Email institucional"> </dxi-column>
                        <dxi-column  dataField="estatuscolaborador" caption="Estatus"> </dxi-column>

                        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                        <div *dxTemplate="let d of 'detail'">
                            <colaborador_detalle [ColaboradorId]="d.data.colaboradorid"></colaborador_detalle>
                        </div>
                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>
